export const layoutTypeToComponentMapper = {
  Admin: 'admin',
  Blank: 'blank'
};
